// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var TaxDefinitionListController = function ($scope, TaxDefinition, gettext) {
    $scope.categories = ["Vat", "Untaxed", "ReverseCharge", "Special", "ExternalTaxCalculation"];

    $scope.canCreate = function (category) {
        return category === 'Untaxed';
    };

    $scope.canEdit = function (taxDefinition) {
        return !taxDefinition.Predefined;
    };

    $scope.isVisible = function (category, taxDefinitions) {
        return taxDefinitions.some(function (tax) {
            return tax.PrimaryCategory === category;
        });
    };
   
    $scope.taxDefinitions = TaxDefinition.query();
    return;

    // ReSharper disable JsUnreachableCode
    // noinspection UnreachableCodeJS
    gettext("Vat");
    gettext("Untaxed");
    gettext("ReverseCharge");
    gettext("Special");
    gettext("ExternalTaxCalculation");
};
TaxDefinitionListController.$inject = ['$scope', 'TaxDefinition', 'gettext'];
